import { styled } from '@mui/material';

const EmptyStateImage = styled('img')(({ theme }) => ({
  maxHeight: '177px',
  marginBottom: theme.spacing(6),
}));

export default EmptyStateImage;
